import * as types from './actionTypes';

const initialFilters = {
  page: 0,
  size: 10,
};

const initialState = {
  rawData: [], // Always an array
  users: [], // Always an array
  total: 0,
  totalElements: 0,
  loading: false,
  submitting: false,
  error: null,
  filters: initialFilters,
};

export default function partnerUserManagementReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_PARTNER_USERS_REQUEST:
      return { ...state, loading: true, error: null };

    case types.FETCH_PARTNER_USERS_SUCCESS: {
      const payload = action.payload || {};
      const list = Array.isArray(payload.data)
        ? payload.data
        : Array.isArray(payload.rawData)
        ? payload.rawData
        : Array.isArray(payload)
        ? payload
        : [];
      const totalCount = payload.totalElements ?? payload.total ?? list.length;

      return {
        ...state,
        loading: false,
        rawData: list,
        users: list,
        total: totalCount,
        totalElements: totalCount,
        filters: payload.filters || state.filters,
        error: null,
      };
    }

    case types.FETCH_PARTNER_USERS_FAILURE:
      return { ...state, loading: false, rawData: [], users: [], error: action.payload };

    case types.CREATE_PARTNER_USER_REQUEST:
    case types.UPDATE_PARTNER_USER_REQUEST:
    case types.DELETE_PARTNER_USER_REQUEST:
    case types.ACTIVATE_PARTNER_USER_REQUEST:
      return { ...state, submitting: true, error: null };

    case types.CREATE_PARTNER_USER_SUCCESS:
    case types.UPDATE_PARTNER_USER_SUCCESS:
    case types.DELETE_PARTNER_USER_SUCCESS:
    case types.ACTIVATE_PARTNER_USER_SUCCESS:
      return { ...state, submitting: false, error: null };

    case types.CREATE_PARTNER_USER_FAILURE:
    case types.UPDATE_PARTNER_USER_FAILURE:
    case types.DELETE_PARTNER_USER_FAILURE:
    case types.ACTIVATE_PARTNER_USER_FAILURE:
      return { ...state, submitting: false, error: action.payload };

    case types.SET_PARTNER_USER_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };

    case types.RESET_PARTNER_USER_FILTERS:
      return { ...state, filters: initialFilters };

    default:
      return state;
  }
}